/* ============================================================
   Kategorietext einklappen (Claude, 17.09.2026)

   Auf Kategorieseiten steht der SEO-Text im Kopfbereich ueber den
   Produkten. Auf dem Smartphone sind das schnell 400 px Text, bevor
   das erste Produkt sichtbar wird. Der Text bleibt vollstaendig im
   HTML (fuer Google und fuer Kunden, die ihn lesen wollen), wird aber
   auf wenige Zeilen gekuerzt und laesst sich aufklappen.

   Greift nicht ein, wenn der Text ohnehin kurz genug ist.
   ============================================================ */
(function () {
  function init() {
    var box = document.querySelector('.collection-hero-banner-caption.collection-description');
    if (!box || box.dataset.clClamp === 'done') return;

    // Erst messen, dann kuerzen: ist der Text kurz, passiert gar nichts.
    var full = box.scrollHeight;
    box.classList.add('cl-desc-clamp');
    var clamped = box.clientHeight;

    if (full - clamped < 40) {
      box.classList.remove('cl-desc-clamp');
      box.dataset.clClamp = 'done';
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cl-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Mehr anzeigen';
    box.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', function () {
      var open = box.classList.toggle('cl-desc-open');
      box.classList.toggle('cl-desc-clamp', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Weniger anzeigen' : 'Mehr anzeigen';
    });

    box.dataset.clClamp = 'done';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
